'use client';
import { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import 'aos/dist/aos.css';
import Image from 'next/image';

const GlassNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isTogglerClicked, setIsTogglerClicked] = useState(false);
  let isHome = true;
  useEffect(() => {
    (async () => {
      const AOS = (await import('aos')).default;
      AOS.init({
        duration: 1000,
        offset: 50,
      });
    })();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50; // You can adjust the number based on your requirement
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    // chechk current page
    if (window.location.pathname === '/') {
      isHome = true;
    } else {
      isHome = false;
    }

    // Add the event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const handleTogglerClick = () => {
    setIsTogglerClicked(!isTogglerClicked);
  };

  return (
    <Navbar
      expand="lg"
      className={`glassy ${scrolled ? 'scrolled-navbar' : ''}`}
    >
      <Container
        className="container-fluid"
        data-aos="fade"
        data-aos-offset="0"
      >
        <Navbar.Brand
          href="/"
          className="mobile-logo"
          data-aos="zoom-in"
          data-aos-offset="0"
        >
          <Image
            src="/assets/logo.png"
            width={scrolled ? 30 : 50}
            height={scrolled ? 30 : 50}
            className="d-inline-block align-top logo-img"
            alt="Centered Logo"
            data-aos="zoom-in"
            data-aos-offset="0"
          />
        </Navbar.Brand>
        <Navbar.Brand
          href="/"
          className={`${scrolled ? 'nav-title-visible' : 'nav-title'}`}
        >
          {/* <h4>Manja</h4> */}
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className={`nav-button ${isTogglerClicked ? 'clicked' : ''}`}
          onClick={handleTogglerClick}
        >
          <FontAwesomeIcon icon={isTogglerClicked ? faTimes : faBars} />
        </Navbar.Toggle>
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="nav-bar-collapse"
        >
          <Nav className="me-auto justify-content-evenly flex-grow-1">
            <Nav.Link
              href="/#"
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              HOME
            </Nav.Link>

            <Nav.Link
              href={isHome ? '/#news' : '/news'}
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              NEWS
            </Nav.Link>
            <Nav.Link
              href="/#results"
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              FIXTURES & RESULTS
            </Nav.Link>
            {/* <Nav.Link href="/#news" className="nav-item" data-aos="zoom-in">
              CHANTS
            </Nav.Link> */}
          </Nav>
          <Navbar.Brand
            href="/"
            className={`desk-logo centered-logo ${
              scrolled ? '' : 'centered-logo-first'
            }`}
            style={{
              marginLeft: 'auto',
            }}
          >
            <Image
              src="/assets/logo.png"
              width={scrolled ? 50 : 80}
              height={scrolled ? 50 : 80}
              className="d-inline-block align-top logo-img"
              alt="Centered Logo"
              data-aos="zoom-in"
              data-aos-offset="0"
            />
          </Navbar.Brand>
          <Nav className="ms-auto justify-content-evenly flex-grow-1">
            {/* extresm right */}

            <Nav.Link
              href={isHome ? '/#gallery' : '/gallery'}
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              GALLERY
            </Nav.Link>

            <Nav.Link
              href="/#about-us"
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              ABOUT US
            </Nav.Link>
            <Nav.Link
              href="/#contact"
              className="nav-item"
              data-aos="zoom-in"
              data-aos-offset="0"
            >
              CONTACT US
            </Nav.Link>
            {/* button with icon */}
            {/* <Nav.Link href="/#contact" className=" button-custom">Click me</Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default GlassNavbar;
